import { Helmet } from 'react-helmet-async';

import { useTranslation } from 'react-i18next';

export const PrivacyPolicyHelmet = () => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;
  return (
    <Helmet>
      <html lang={currentLanguage.slice(0, 2)} />
      <title>{t('HELMET.PRIVACY_POLICY.TITLE')}</title>
      <meta
        name="description"
        content={t('HELMET.PRIVACY_POLICY.DESCRIPTION')}
      />
      <link rel="canonical" href="https://www.slex.tv//privacy-policy" />

      {/* Twitter */}
      <meta name="twitter:title" content={t('HELMET.PRIVACY_POLICY.TITLE')} />
      <meta
        name="twitter:description"
        content={t('HELMET.PRIVACY_POLICY.DESCRIPTION')}
      />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={t('HELMET.PRIVACY_POLICY.TITLE')} />
      <meta
        property="og:description"
        content={t('HELMET.PRIVACY_POLICY.DESCRIPTION')}
      />
      <meta property="og:url" content="https://www.slex.tv//privacy-policy" />
    </Helmet>
  );
};

export const TermsConditionsHelmet = () => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;
  return (
    <Helmet>
      <html lang={currentLanguage.slice(0, 2)} />
      <title>{t('HELMET.TERMS_AND_CONDITIONS.TITLE')}</title>
      <meta
        name="description"
        content={t('HELMET.TERMS_AND_CONDITIONS.DESCRIPTION')}
      />
      <link rel="canonical" href="https://www.slex.tv//terms-and-conditions" />

      {/* Twitter */}
      <meta
        name="twitter:title"
        content={t('HELMET.TERMS_AND_CONDITIONS.TITLE')}
      />
      <meta
        name="twitter:description"
        content={t('HELMET.TERMS_AND_CONDITIONS.DESCRIPTION')}
      />

      {/* Open Graph / Facebook */}
      <meta
        property="og:title"
        content={t('HELMET.TERMS_AND_CONDITIONS.TITLE')}
      />
      <meta
        property="og:description"
        content={t('HELMET.TERMS_AND_CONDITIONS.DESCRIPTION')}
      />
      <meta
        property="og:url"
        content="https://www.slex.tv//terms-and-conditions"
      />
    </Helmet>
  );
};

export const RefundPolicyHelmet = () => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;
  return (
    <Helmet>
      <html lang={currentLanguage.slice(0, 2)} />
      <title>{t('HELMET.REFUND_POLICY.TITLE')}</title>
      <meta
        name="description"
        content={t('HELMET.REFUND_POLICY.DESCRIPTION')}
      />
      <link rel="canonical" href="https://www.slex.tv//refund-policy" />

      {/* Twitter */}
      <meta name="twitter:title" content={t('HELMET.REFUND_POLICY.TITLE')} />
      <meta
        name="twitter:description"
        content={t('HELMET.REFUND_POLICY.DESCRIPTION')}
      />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={t('HELMET.REFUND_POLICY.TITLE')} />
      <meta
        property="og:description"
        content={t('HELMET.REFUND_POLICY.DESCRIPTION')}
      />
      <meta property="og:url" content="https://www.slex.tv//refund-policy" />
    </Helmet>
  );
};
